"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var inputStatesCSS = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), function (props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background: ", ";\n      "])), function (props) {
      return props.theme.colors.white[700];
    });
  }
}, function (props) {
  if (props.isValid === false) {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        box-shadow: inset 0 -1px 1px ", ";\n        color: ", ";\n      "])), props.theme.colors.red[500], props.theme.colors.red[500]);
  }
});
var _default = inputStatesCSS;
exports.default = _default;